import { http } from 'vue'

export default {
  // create contact at the API server
  postContact (context, params = {}) {
    return http.post('contacts', params.data)
  },
  // edit contact at the API server
  putContact (context, params = {}) {
    return http.put('contacts/' + params.id, params.data)
  },
  // delete contact at the API server
  deleteContact (context, params = {}) {
    return http.delete('contacts/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts/actions.js